import React, { Fragment, useContext } from 'react';
import { warName, apiDomain } from '../..';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { formatDateWithWeekDay, getConfiguration } from '../../data/utils';
import { getLabel } from '../../data/labels';
import { getPrintCSS } from './printCSS';
import Img from '../../common/util/Img';

function getAlias(odd, bet, useCustomizedAlias) {
    const systemCode = getConfiguration().sys;
    let aliasList = [];
    // checking if there is an alias customization for this skin
    if (useCustomizedAlias) {
        let customizedAliasList = odd.aliasBySystemCode ? odd.aliasBySystemCode[systemCode] : null;
        if ((customizedAliasList == null || customizedAliasList.length === 0) && odd.aliasHandicapBySystemCode) {
            // searching it in the aliasByHandicapSystemCodeMap
            customizedAliasList = odd.aliasHandicapBySystemCode[`${systemCode}_${bet.handicap}`];
        }
        if (customizedAliasList != null && customizedAliasList.length > 0) {
            aliasList = customizedAliasList;
        }
    } else {
        if (odd.aliasListDefault != null && odd.aliasListDefault.length > 0) {
            aliasList = odd.aliasListDefault;	
        } else if(odd.aliasByHandicap != null && odd.aliasByHandicap[bet.handicap] != null) {
            aliasList = odd.aliasByHandicap[bet.handicap];
        }
    }

    if (aliasList.length > 0) {
        return aliasList[0];
    } else {
        return '-';
    }
}

function getMaxRows(align) {
    return align === 'vertical' ? 60 : 40;
}

function splitMatchesByDate(tournaments, align) {
    const pages = [[]];
    let matches = [];
    tournaments.forEach(t => {
        t.events.forEach(function(match) {
            // const date = match.ts.split(' ')[0];  // Prendi solo la data
            match.date = formatDateWithWeekDay(match.ts).dayMonth
            match.sportDesc = t.sportDesc;
            match.categoryDesc = t.categoryDesc;
            match.tournamentDesc = t.descrizione || t.desc;
            matches.push(match);
        });
    });
    matches.sort((a, b) => a.ts.localeCompare(b.ts));
    let pagesIndex = 0;
    let currentDate = '';
    let totalRows = 0;
    matches.forEach(m => {
        let rowsToAdd = 1;
        if (currentDate !== m.date) {
            rowsToAdd = 2;
            currentDate = m.date;
        }
        if (totalRows + rowsToAdd > getMaxRows(align)) {
            pages.push([]);
            pagesIndex++;
            totalRows = 0;
            rowsToAdd = 2;
        }
        pages[pagesIndex].push(m);
        totalRows += rowsToAdd;
    });

    return pages;
}

function splitMatchesByTournament(tournaments, align) {
    const pages = [[]];
    tournaments.forEach(t => {
        t.dates = [];
        t.matchesByDate = {};
        t.events.forEach(function(match) {
            const timestamp = match.ts.split(' ')[0];  // Prendi solo la data
            if (t.matchesByDate[timestamp] == null) {
                t.matchesByDate[timestamp] = [];
                t.dates.push(timestamp);
            }
            match.sportDesc = t.sportDesc;
            match.categoryDesc = t.categoryDesc;
            match.tournamentDesc = t.descrizione || t.desc;
            t.matchesByDate[timestamp].push(match);
        });
        t.dates.sort();
    });
    let matches = [];
    tournaments.forEach(t => {
        t.dates.forEach(date => {
            const formattedDate = formatDateWithWeekDay(`${date} 00:00`).dayMonth;
            const matchesList = t.matchesByDate[date].sort((a, b) => a.ts.localeCompare(b.ts));
            matchesList.forEach(m => m.date = formattedDate);
            matches.push(...matchesList);
        });
    });
    let pagesIndex = 0;
    let currentTournament = '';
    let currentDate = '';
    let totalRows = 0;
    matches.forEach(m => {
        let rowsToAdd = 1;
        if (currentTournament !== m.tournamentDesc) {
            rowsToAdd++;
            currentTournament = m.tournamentDesc;
            currentDate = '';
        }
        if (currentDate !== m.date) {
            rowsToAdd++;
            currentDate = m.date;
        }
        if (totalRows + rowsToAdd > getMaxRows(align)) {
            pages.push([]);
            pagesIndex++;
            totalRows = 0;
            rowsToAdd = 3;
        }
        pages[pagesIndex].push(m);
        totalRows += rowsToAdd;
    });

    return pages;
}

function splitMatchesByDateAndTournament(tournaments, align) {
    const pages = [[]];
    const dates = [];
    const tournamentsByDate = {};
    tournaments.forEach(t => {
        t.events.forEach(function(match) {
            const timestamp = match.ts.split(' ')[0];  // Prendi solo la data
            if (tournamentsByDate[timestamp] == null) {
                tournamentsByDate[timestamp] = [];
                dates.push(timestamp);
            }
            match.sportDesc = t.sportDesc;
            match.categoryDesc = t.categoryDesc;
            match.tournamentDesc = t.descrizione || t.desc;
            const tournament = tournamentsByDate[timestamp].find(tournament => tournament.id === t.id);
            if (tournament === undefined) {
                tournamentsByDate[timestamp].push({
                    ...t,
                    events: [match]
                });
            } else {
                tournament.events.push(match);
            }
        });
    });
    dates.sort();
    let matches = [];
    dates.forEach(date => {
        const tournaments = tournamentsByDate[date];
        tournaments.forEach(t => {
            const formattedDate = formatDateWithWeekDay(`${date} 00:00`).dayMonth;
            const matchesList = t.events.sort((a, b) => a.ts.localeCompare(b.ts));
            matchesList.forEach(m => m.date = formattedDate);
            matches.push(...matchesList);
        });
    });
    let pagesIndex = 0;
    let currentDate = '';
    let currentTournament = '';
    let totalRows = 0;
    matches.forEach(m => {
        let rowsToAdd = 1;
        if (currentDate !== m.date) {
            rowsToAdd++;
            currentDate = m.date;
            currentTournament = '';
        }
        if (currentTournament !== m.tournamentDesc) {
            rowsToAdd++;
            currentTournament = m.tournamentDesc;
        }
        if (totalRows + rowsToAdd > getMaxRows(align)) {
            pages.push([]);
            pagesIndex++;
            totalRows = 0;
            rowsToAdd = 3;
        }
        pages[pagesIndex].push(m);
        totalRows += rowsToAdd;
    });

    return pages;
}

function splitInPages(tournaments, settings) {
    let pages = null;
    switch (settings.sortType) {
        default:
        case 'date':
            pages = splitMatchesByDate(tournaments, settings.align);
            break;
        case 'tournament':
            pages = splitMatchesByTournament(tournaments, settings.align);
            break;
        case 'dateAndTournament':
            pages = splitMatchesByDateAndTournament(tournaments, settings.align);
            break;
    }

    return pages;
}

function renderMatchesByDate(matches) {
    const conf = getConfiguration();
    let currentDate = '';
    return matches.map((match, matchIndex) => {
        const showDate = match.date !== currentDate;
        if (showDate) {
            currentDate = match.date;
        }
        const parts = formatDateWithWeekDay(match.ts).dayMonthTime.split(' - ');
        const formattedTime = parts[1];
        return (
            <React.Fragment key={matchIndex}>
                {showDate &&
                    <tr className="rigaOrario">
                        <td colSpan="35">{match.date}</td>
                    </tr>
                }
                <tr className="rigaValorizzata">
                    <td>{match.al}</td>
                    <td>{formattedTime}</td>
                    {conf.stp &&
                        <td>{match.tournamentDesc}</td>
                    }
                    <td>{match.desc}</td>
                    {match.scs.map(bet => {
                        return bet.odds.map((odd, i) => {
                            return (
                                <td key={i} className="quota">{odd.value && odd.value > 0 ? odd.value : '-'}</td>
                            );
                        });
                    })}
                </tr>
            </React.Fragment>
        );
    });
}

function renderMatchesByTournament(matches) {
    let currentTournament = null;
    let currentDate = '';
    return matches.map((match, matchIndex) => {
        const parts = formatDateWithWeekDay(match.ts).dayMonthTime.split(' - ');
        const formattedTime = parts[1];
        const showTournamentDesc = match.it !== currentTournament;
        if (showTournamentDesc) {
            currentTournament = match.it;
        }
        const showDate = showTournamentDesc || match.date !== currentDate;
        if (showDate) {
            currentDate = match.date;
        }
        return (
            <Fragment key={matchIndex}>
                {showTournamentDesc &&
                    <tr className="rigaManifestazione">
                        <td colSpan="35">{match.categoryDesc} - {match.tournamentDesc}</td>
                    </tr>
                }
                {showDate &&
                    <tr className="rigaOrario">
                        <td colSpan="35">{match.date}</td>
                    </tr>
                }
                <tr className="rigaValorizzata">
                    <td>{match.al}</td>
                    <td>{formattedTime}</td>
                    <td>{match.desc}</td>
                    {match.scs.map(bet => {
                        return bet.odds.map((odd, oddIndex) => {
                            return (
                                <td key={oddIndex} className="quota">{odd.value && odd.value > 0 ? odd.value : '-'}</td>
                            );
                        })
                    })}
                </tr>
            </Fragment>
        );
    });
}

function renderMatchesByDateAndTournament(matches) {
    let currentDate = '';
    let currentTournament = null;
    return matches.map((match, matchIndex) => {
        const parts = formatDateWithWeekDay(match.ts).dayMonthTime.split(' - ');
        const formattedTime = parts[1];
        const showDate = match.date !== currentDate;
        if (showDate) {
            currentDate = match.date;
        }
        const showTournamentDesc = showDate || match.it !== currentTournament;
        if (showTournamentDesc) {
            currentTournament = match.it;
        }
        return (
            <Fragment key={matchIndex}>
                {showDate &&
                    <tr className="rigaOrario">
                        <td colSpan="35">{match.date}</td>
                    </tr>
                }
                {showTournamentDesc &&
                    <tr className="rigaManifestazione">
                        <td colSpan="35">{match.categoryDesc} - {match.tournamentDesc}</td>
                    </tr>
                }
                <tr className="rigaValorizzata">
                    <td>{match.al}</td>
                    <td>{formattedTime}</td>
                    <td>{match.desc}</td>
                    {match.scs.map(bet => {
                        return bet.odds.map((odd, oddIndex) => {
                            return (
                                <td key={oddIndex} className="quota">{odd.value && odd.value > 0 ? odd.value : '-'}</td>
                            );
                        })
                    })}
                </tr>
            </Fragment>
        );
    });
}

export function PrintIframeContent(props) {
    const betslipContext = useContext(BetslipContext);
    const useCustomizedAlias = betslipContext.enableCustomAliases;
    const data = {
        groups: props.groups,
        groupByBet: props.groupByBet
    };
    const settings = props.settings;

    if (data == null) {
        return null;
    }

    const conf = getConfiguration();
    const showTournamentColumn = conf.stp && settings.sortType === 'date';

    return (
        <>
            <style dangerouslySetInnerHTML={{__html: getPrintCSS(settings)}} />
            <div id="content">
                <table id="container-table">
                    <thead>
                        <tr>
                            <th>
                                <div className={!settings.logoOnAllPages ? 'spaceForHeader' : ''}>
                                    <div className={!settings.logoOnAllPages ? 'onlyprint1' : ''}>
                                        <div className="floatLeft">
                                            <img src={`${apiDomain}/${warName}/content/images/customer-logo/${conf.logo}`} className="customerLogo" />
                                        </div>
                                        {!conf.nas &&
                                            <div className="floatRight">
                                                <Img id="logo-aams" src="assets/img/sport/loghi_aams.png" className="aamsLogo" />
                                            </div>
                                        }
                                    </div>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                {data.groups.map((tournaments, groupIndex) => {
                                    const pages = splitInPages(tournaments, settings);
                                    return (
                                        <React.Fragment key={groupIndex}>
                                            {pages.map((matches, pageIndex) => {
                                                const firstMatchBets = matches[0].scs.filter(bet => {
                                                    const betId = `${bet.id}_${bet.handicap}`;
                                                    return data.groupByBet[betId] === groupIndex;
                                                });
                                                return (
                                                    <React.Fragment key={pageIndex}>
                                                        {/*  <br /> this line break causes a blank page in landscape printing mode on Google Chrome's printing tools */}
                                                        <table className="oddsTable">
                                                            <tbody>
                                                                <tr className="headerPrincipale">
                                                                    <td className="rigaVuotaAliasDataOraEvento" colSpan={showTournamentColumn ? 4 : 3}>{matches[0].sportDesc}</td>
                                                                    {firstMatchBets.map((bet, betIndex) => {
                                                                        return (
                                                                            <td key={betIndex} className="headerDescScomm" colSpan={bet.odds.length}>{bet.desc}</td>
                                                                        );
                                                                    })}
                                                                </tr>
                                                                <tr className="subHeader">
                                                                    <td colSpan={showTournamentColumn ? 4 : 3}>{getLabel('prematch_page.print_bets.print_window_table_header_alias_code')}</td>
                                                                    {firstMatchBets.map(bet => {
                                                                        return bet.odds.map((odd, oddIndex) => {
                                                                            return (
                                                                                <td key={oddIndex} className="descEsito" colSpan={1}>{getAlias(odd, bet, useCustomizedAlias)}</td>
                                                                            );
                                                                        });
                                                                    })}
                                                                </tr>
                                                                <tr className="subHeader">
                                                                    <td>{getLabel('prematch_page.print_bets.print_window_table_header_alias')}</td>
                                                                    <td>{getLabel('prematch_page.print_bets.print_window_table_header_time')}</td>
                                                                    {showTournamentColumn &&
                                                                        <td>{getLabel('prematch_page.print_bets.print_window_table_header_tournament')}</td>
                                                                    }
                                                                    <td>{getLabel('prematch_page.print_bets.print_window_table_header_event')}</td>
                                                                    {firstMatchBets.map(bet => {
                                                                        return bet.odds.map((odd, oddIndex) => {
                                                                            return (
                                                                                <td key={oddIndex} className="descEsito" colSpan={1}>{odd.desc}</td>
                                                                            );
                                                                        });
                                                                    })}
                                                                </tr>
                                                                {(() => {
                                                                    switch (settings.sortType) {
                                                                        default:
                                                                        case 'date':
                                                                            return renderMatchesByDate(matches);
                                                                        case 'tournament':
                                                                            return renderMatchesByTournament(matches);
                                                                        case 'dateAndTournament':
                                                                            return renderMatchesByDateAndTournament(matches);
                                                                    }
                                                                })()}
                                                                </tbody>
                                                        </table>
                                                        {/* (pageIndex < pages.length-1) &&  */
                                                            <p><br /><br /><br /></p>
                                                        }
                                                    </React.Fragment>
                                                );
                                            })}
                                        </React.Fragment>
                                    );
                                })}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    );
}

export default PrintIframeContent;